import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { inr, fmtPct, pct } from '../../utils/format';

function BannerStat({ label, value, sub, gold }) {
  return (
    <Box sx={{ minWidth: 150 }}>
      <Box sx={{ fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--tealink)' }}>
        {label}
      </Box>
      <Box sx={{ fontFamily: 'var(--disp)', fontWeight: 700, fontSize: 28, color: gold ? 'var(--gold)' : '#fff', mt: '6px' }}>
        {value}
      </Box>
      <Box sx={{ fontFamily: 'var(--mono)', fontSize: 10, color: 'var(--tealdim)', mt: '4px', letterSpacing: '.05em' }}>
        {sub}
      </Box>
    </Box>
  );
}

/** Dark headline strip under the KPI row — four figures on the 12-column grid. */
export default function RevenueBanner({ agg: a, range, influencerTotal, pending = false }) {
  return (
    <Box
      sx={{
        background: 'linear-gradient(120deg,#123a2b,#0c281d)',
        borderRadius: '16px',
        p: '22px 24px',
        color: '#dbe7e0',
        mb: 2.75,
      }}
    >
      <Grid container spacing={3.75} sx={{ alignItems: 'center' }}>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <BannerStat gold label="Revenue Logged" value={inr(a.rev)} sub={`${a.n} transactions · ${range} days`} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <BannerStat label="Contribution Margin" value={inr(a.margin)} sub={`${fmtPct(a.marginPct)} of revenue`} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <BannerStat label="Influencer Payout" value={pending ? "…" : inr(influencerTotal)} sub={pending ? "loading" : `${fmtPct(pct(influencerTotal, a.rev))} of revenue`} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <BannerStat label="Net After Payout" value={pending ? "…" : inr(a.margin - influencerTotal)} sub="Margin − influencer cost" />
        </Grid>
      </Grid>
    </Box>
  );
}
